// extracted by mini-css-extract-plugin
export default {"toolbarContainer":"commonEditTeam_toolbarContainer__I42CV"};